export default import.meta.ROLLUP_FILE_URL_ZSeGjX2en18YD_JsblYTRA